<template>
  <div>
    <SubNav
      :link="{
        text: '&lt; Back to User Management',
        href: 'list',
        class: 'text-danger',
      }"
    />
    <div class="container-fluid pb-1">
      <div class="mb-sm-4 mx-3 my-4 row">
        <div class="col-lg-12">
          <div class="border p-4">
            <div class="mb-4">
              <h4 class="text-primary mt-2">Invite New Member</h4>
              <strong>User Details</strong>
            </div>
            <b-form
              v-if="show"
              v-loading="submittingForm"
              class="row"
              @submit.prevent="onSubmit"
              @reset.prevent="onReset"
            >
              <div class="col-md-3 mb-3">
                <label for="firstName">First name</label>
                <input
                  id="firstName"
                  v-model="form.first_name"
                  placeholder="First name"
                  class="form-control"
                  disabled
                />
              </div>
              <div class="col-md-3 mb-3">
                <label for="lastName">Last name</label>
                <input
                  id="lastName"
                  v-model="form.last_name"
                  placeholder="Last name"
                  class="form-control"
                  disabled
                />
              </div>
              <div class="col-md-6 mb-3">
                <label for="email">Email*</label>
                <input
                  id="email"
                  v-model="form.email"
                  type="email"
                  placeholder="Enter email address to invite"
                  class="form-control"
                  required
                />
              </div>
              <dropCard
                name="role"
                placeholder="Please select role"
                label="Select Role"
                :list="roles"
                :value.sync="form.type"
              >
                <!-- <CreateRole /> -->
              </dropCard>

              <div class="col-12 my-5">
                <b-button type="submit" class="mr-2 action-btn btn shadow" variant="primary">
                  Send Invitation
                  <b-icon icon="cursor-fill"></b-icon>
                </b-button>
                <b-button
                  type="reset"
                  class="action-btn btn shadow"
                  variant="danger"
                  @click="$router.back()"
                  >Cancel</b-button
                >
              </div>
            </b-form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SubNav from "../../components/SubNav.vue";
import userResource from "../../api/userResource";
// import CreateRole from "../roles/components/Create";
import dropCard from "../../components/dropCard.vue";
import { logUserAction } from "../../utils/activityLogger";

import { mapGetters } from "vuex";

const initForm = {
  email: "",
  // first_name: "",
  // last_name: "",
  type: -1,
};

export default {
  name: "InviteUser",
  components: { SubNav, dropCard },
  data() {
    return {
      title: "Invite new member",
      submittingForm: false,
      form: initForm,
      show: true,
      roles: [
        { id: 0, name: "data_viewer" },
        { id: 1, name: "data manager" },
        { id: 2, name: "super admin" },
        { id: 3, name: "admin" },
      ],
    };
  },
  computed: {
    ...mapGetters(["roles"]),
  },
  methods: {
    async onSubmit() {
      if (this.form.type < 0) {
        return this.$notify.error("No role selected!");
      }
      try {
        this.submittingForm = true;
        // eslint-disable-next-line no-unused-vars
        const response = await userResource.invite(this.form);

        // Log user invitation activity
        logUserAction("invite", {
          email: this.form.email,
          username: this.form.email,
        });

        this.$notify({
          message: `Invite sent to ${this.form.email}`,
          type: "success",
          duration: 0,
        });
      } catch (error) {
        console.error(error);
        this.$notify.error("Error processing request");
      } finally {
        this.submittingForm = false;
      }
    },
    onReset() {
      this.form = initForm;
      this.show = false;
      this.$nextTick(() => {
        this.show = true;
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.action-btn {
  width: 170px;
}
.user-roles {
  max-height: 270px;
  overflow-y: auto;
  scroll-behavior: smooth;
}
</style>
